/**
 * Map name for mutations
 * @types {string}
 */
export const SET_PARAM = "VIEWS/SET_PARAM";
export const SET_MISSION_MENU = "VIEWS/SET_MISSION_MENU";
export const SET_ALCADAS = "VIEWS/SET_ALCADAS";
export const TOGGLE_ALCADAS = "VIEWS/TOGGLE_ALCADAS";
export const TOGGLE_TOUR_PRESENTATION_STATUS = "VIEWS/TOGGLE_TOUR_PRESENTATION_STATUS";
export const TOGGLE_SHOW_CARD_STORES = "VIEWS/TOGGLE_SHOW_CARD_STORES";
export const SET_COMPONENT_OR_ELEMENT = "VIEWS/SET_COMPONENT_OR_ELEMENT";